const SKELETON_COUNT = 8;

const WindowSkeleton = () => {
  return (
    <div role="status" aria-busy="true">
      <span className="sr-only">Loading available times</span>
      <div className="status-keys-container">
        {Array.from({length: 3}).map((_, i) => (
          <div className="status-key-container" key={i}>
            <div className="status-key animate-pulse bg-lightest-gray border-light-gray" />
            <span className="inline-block w-12 h-3 animate-pulse bg-lightest-gray rounded" />
          </div>
        ))}
      </div>
      <div className="p-2 row-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
        {Array.from({length: SKELETON_COUNT}).map((_, i) => (
          <div className="window" key={i}>
            <div className="flex flex-col items-center justify-center rounded-lg border border-light-gray bg-lightest-gray w-full animate-pulse">
              <p className="text-sm font-bold py-2 text-transparent select-none" aria-hidden="true">
                00:00 AM
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WindowSkeleton;
